import API from '../../../API/api';
import {types} from '../../../_constants/product/types';
import {setProductBatchStocksAction} from '../../actions/product_batch_stocks_actions';
import {
    productBatchStocksStarted,
    productBatchStocksSuccess,
    productBatchStocksFailed
} from '../../actions/http_request/product_batch_stocks_actions';

const { store } = TYROOLA.globals;

/**
 * @param productType
 * @param products
 * @returns {*}
 */
function productBatchStocksRequest(productType, products) {
    if (types.TYRE_CAR !== productType
        || typeof products === 'undefined'
        || products.length < 1
        || ['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(store) < 0) {
        return Promise.resolve([]);
    }

    'use strict';
    let productCodes = [];
    products.forEach((product) => {
        productCodes.push(product.sku);
    });

    productBatchStocksStarted();
    return API.GET({
        apiPath: '/api/v2/productsbatch/mixedstocks/availablequantity/?productCodes=' + productCodes.join(','),
        dataType: 'json',
    }).catch(response => {
        productBatchStocksFailed();
    }).done(response => {
        productBatchStocksSuccess();
        setProductBatchStocksAction(response);
    });
}

export default productBatchStocksRequest;
